export const BLANK_ROUTE: string = '/';
export const MAIN_ROUTE: string = '/main';  // '/'
export const ADMIN_ROUTE: string = '/admin';
export const PROJECT_ROUTE: string = '/projects';
export const SERVISES_ROUTE: string = '/servises';
export const SYSTEMS_ROUTE: string = '/systems';
export const VACANCY_ROUTE: string = '/vacancy';